import { getServer } from "@/Utlis/connections/aplication/getServer"
import { ConnectionRepository } from "@/Utlis/connections/infraestructure/ConnectionRepository"

export function UserRepository() {
    return {
        getUser,
        getUserById
    }
}

const connect = ConnectionRepository()

async function getUser(nick) {
    try {
        const user = await getServer(connect, `v6/user/public/${nick}`)
        return user.data
    } catch (error) {
        console.error(`Error in UserRepository Method get User: ${error}`);
        return null
    }
}

async function getUserById(id) {
    try {
        const user = await getServer(connect, `v2/public/user/${id}`)
        return user.data
    } catch (error) {
        console.error(`Error in UserRepository Method get User: ${error}`);
        return null
    }
}
